export default "__VITE_ASSET__ir04VbB$__"